import React, { useState, useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { APP_NAME } from '../../constants/general'

import { set, useForm } from 'react-hook-form';
import PlantSitting from '../../class/PlantSitting';

function PsModifierAnnonce() {

    const { id } = useParams()

    const navigate = useNavigate()

    const [annonce, setAnnonce] = useState(false)
    const [categorie, setCategorie] = useState(1)

    const [loading, setLoading] = useState(true)

    // const [frequence, setFrequence] = useState(1)

    const [o1, setO1] = useState(false)
    const [o2, setO2] = useState(false)
    const [o3, setO3] = useState(false)

    const {
        register,
        handleSubmit,
        setError,
        setValue,
        formState: { errors, isSubmitting }
    } = useForm()

    const onSubmit = async (data) => {

        let option1 = o1 ? data.tarif1 : 0
        let option2 = o2 ? data.tarif2 : 0
        let option3 = o3 ? data.tarif3 : 0

        if (option1 == 0 && option2 == 0 && option3 == 0) {

            setError('err', { message: 'Sélectionne au moins une option' })

            return

        }

        let results = await PlantSitting.post('modifier', {
            annonce_id: id,
            categorie: data.categorie,
            titre: data.titre,
            ville: data.ville,
            description: data.description,
            option1: option1,
            option2: option2,
            option3: option3
        })

        if (results.success == true) {

            navigate('/plant-sitting/annonce/' + id)

        } else {

            setError('err', { message: results.message })

        }

    }

    const getAnnonce = async () => {

        let results = await PlantSitting.post('annonceById', { id: id })

        if (results.success) {

            setLoading(false)

            if (results.data.user_id != localStorage.idU) navigate('/404')

            setAnnonce(results.data)

            setValue('categorie', results.data.categorie_id)

            setValue('titre', results.data.titre)
            setValue('ville', results.data.ville)
            setValue('description', results.data.description)

            setCategorie(results.data.categorie_id)

            if (results.data.tarif1 > 0) {
                setO1(true)
                setValue('tarif1', results.data.tarif1)
            }
            if (results.data.tarif2 > 0) {
                setO2(true)
                setValue('tarif2', results.data.tarif2)
            }
            if (results.data.tarif3 > 0) {
                setO3(true)
                setValue('tarif3', results.data.tarif3)
            }

            setValue('frequence', results.data.frequence)

            // setFrequence(results.data.frequence)



        } else {

            navigate('/404')

        }

    }

    useEffect(() => {

        getAnnonce()

        document.title = "Proposer un plant sitting - " + APP_NAME

    }, [])

    return (

        <div>

            <Header />

            <div className="plantsitting">

                <HeaderBox />

                {

                    !loading

                        ?

                        <div className="single">

                            <div className='content'>

                                <div className='c'>

                                    <form method="POST" className="gla-form" onSubmit={handleSubmit(onSubmit)}>

                                        <p className='fz11'>Pour proposer plusieurs services (arrosage, gardiennage, jardinage…), tu dois créer une annonce séparée pour chaque service.</p>

                                        <input type="hidden" {...register('err')} />

                                        <div className="bg7 br8 p40 mt20 ta-center">

                                            <div>

                                                <label>
                                                    <span>Catégorie</span>
                                                    <select {...register("categorie")} onChange={(e) => setCategorie(e.target.value)} disabled={true}>
                                                        <option value={1} selected={categorie == 1}>Je garde tes plantes chez moi</option>
                                                        <option value={2} selected={categorie == 2}>J'arrose tes plantes chez toi</option>
                                                        <option value={3} selected={categorie == 3}>J'offre un service de jardinage</option>
                                                    </select>
                                                </label>
                                                <label>
                                                    <span>Ville</span>
                                                    <input type="text" {...register("ville")} placeholder="ex : Paris, 9eme" rows="1" required={true} />
                                                </label>
                                                <label>
                                                    <span>Titre</span>
                                                    <input type="text" {...register("titre")} placeholder="ex : Je garde et j’arrose vos plantes avec soin" rows="1" required={true} />
                                                </label>
                                                <label>
                                                    <span>Description</span>
                                                    <textarea {...register("description")} placeholder="ex : Vous partez en vacances, vous souhaitez que je passe arroser vos plante ou tondre la pelouse ?" required={true}></textarea>
                                                </label>
                                            </div>

                                        </div>

                                        <div className="bg7 br8 p40 mt20">

                                            <div>

                                                {

                                                    (categorie == 1 || categorie == 2)

                                                    &&

                                                    <label>
                                                        <span>Tarif par jour (€)</span>
                                                        <div className="grid3 col-65 m_mt_20">
                                                            <div className='m_flex m_f_direction'>
                                                                <input type="number" {...register("tarif1")} defaultValue={annonce.tarif1 > 0 ? annonce.tarif1 : null} placeholder="0.00 €" required={true} disabled={!o1} className='fz12' />
                                                                <div className='flex jc-start m_flex'>
                                                                    <input type="checkbox" checked={o1} onChange={(e) => setO1(e.target.checked)} />
                                                                    <p className='fz09 ml10'>jusqu'à 30 plantes</p>
                                                                </div>
                                                            </div>

                                                            <div className='m_flex m_f_direction'>
                                                                <input type="number" {...register("tarif2")} defaultValue={annonce.tarif2 > 0 ? annonce.tarif2 : null} placeholder="0.00 €" required={true} disabled={!o2} className='fz12' />
                                                                <div className='flex jc-start m_flex'>
                                                                    <input type="checkbox" checked={o2} onChange={(e) => setO2(e.target.checked)} />
                                                                    <p className='fz09 ml10'>supérieur à 30 plantes</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </label>

                                                }

                                                {

                                                    categorie == 3

                                                    &&

                                                    <label>
                                                        <span>Tarif jour (€)</span>
                                                        <div className="grid3 col-65 m_mt_20">

                                                            <div className='m_flex m_f_direction'>
                                                                <input type="number" {...register("tarif1")} defaultValue={annonce.tarif1 > 0 ? annonce.tarif1 : null} placeholder="0.00 €" required={true} disabled={!o1} className='fz12' />
                                                                <div className='flex jc-start m_flex'>
                                                                    <input type="checkbox" checked={o1} onChange={(e) => setO1(e.target.checked)} />
                                                                    <p className='fz09 ml10'>Tondre</p>
                                                                </div>
                                                            </div>

                                                            <div className='m_flex m_f_direction'>
                                                                <input type="number" {...register("tarif2")} defaultValue={annonce.tarif2 > 0 ? annonce.tarif2 : null} placeholder="0.00 €" required={true} disabled={!o2} className='fz12' />
                                                                <div className='flex jc-start m_flex'>
                                                                    <input type="checkbox" checked={o2} onChange={(e) => setO2(e.target.checked)} />
                                                                    <p className='fz09 ml10'>Tailler</p>
                                                                </div>
                                                            </div>

                                                            <div className='m_flex m_f_direction'>
                                                                <input type="number" {...register("tarif3")} defaultValue={annonce.tarif3 > 0 ? annonce.tarif3 : null} placeholder="0.00 €" required={true} disabled={!o3} className='fz12' />
                                                                <div className='flex jc-start m_flex'>
                                                                    <input type="checkbox" checked={o3} onChange={(e) => setO3(e.target.checked)} />
                                                                    <p className='fz09 ml10'>Netoyer et autre</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </label>

                                                }

                                                {errors.err && <p className="error">{errors.err.message}</p>}

                                            </div>

                                        </div>

                                        <div className="ta-end mt20">
                                            <input type="submit" name="submit" value={isSubmitting ? 'Envoi...' : 'Modifier'} className="btn bg3 cl5 brc3 brc1solid" disabled={isSubmitting} style={{ opacity: isSubmitting ? '0.2' : '1' }} />
                                        </div>
                                    </form>

                                </div>

                            </div>

                        </div>

                        :

                        <div className="c pb40">


                            <div className='flex jc-center mt50 mb50'>
                                <div className="lds-dual-ring col"></div>
                            </div>


                        </div>

                }

                <Footer />

            </div>

        </div>

    )

}

export default PsModifierAnnonce